define('LNRS/Components/Forms/NonEloquaBase',[
    "jquery",
    "Utility/ErrorHandler",
    "eventManager",
    "Track/Events"
], function ($, errorHandler, eventManager, events) {
    "use strict";

    function validateRegex(regex, value) {
        if (!regex) { return true; }
        var re = new RegExp(regex, "g");
        return re.test(value);
    }

    function getError(inputNameFor, message) {
        var errorArray = {};
        errorArray[inputNameFor] = message;
        return errorArray;
    }

    function NonEloquaBase() { }

    NonEloquaBase.prototype.loadRecaptchaCallback = function loadRecaptchaCallback(recaptchaContainerElements, recaptchaCallback) {
        if (!recaptchaContainerElements) { return; }

        var sitekey = recaptchaContainerElements[0].dataset.sitekey;
        recaptchaContainerElements.each(function (index, element) {

            if (!$(element).attr("is-recaptcha-rendered")) {
                grecaptcha.render(element, {
                    'sitekey': sitekey,
                    'callback': recaptchaCallback
                });

                $(element).attr("is-recaptcha-rendered", true);
            }
        });
    };

    NonEloquaBase.prototype.loadRecaptchaCallbackV3 = function loadRecaptchaCallbackV3(recaptchaContainerElements, recaptchaCallback) {
        if (!recaptchaContainerElements) { return; }

        var sitekey = recaptchaContainerElements[0].dataset.sitekey;
        recaptchaContainerElements.each(function (index, element) {

            if (!$(element).attr("is-recaptcha-rendered")) {

                var clientId = grecaptcha.render(element, {
                    'sitekey': sitekey,
                    'badge': 'inline',
                    'size': 'invisible',
                    'callback': recaptchaCallback
                });

                $(element).siblings('.recaptchaClientId').first().val(clientId);

                var actionName = $(element).siblings('.recaptchaActionName').first().val();
                
                grecaptcha.ready(function () {
                    grecaptcha.execute(clientId, { action: actionName })
                        .then(function (token) {
                            console.log('ReCaptcha V3 Loaded');
                        });
                });

                $(element).attr("is-recaptcha-rendered", true);
            }
        });
    };

    NonEloquaBase.prototype.validateInput = function validateInput(el, isForSubmition, errorList) {
        if (!el) { return null; }
        var errIndex = errorList.indexOf(el.id);
        if (el.value && (el.type === "incomplete" || !validateRegex(el.dataset.valRegexPattern, el.value))) {
            if (errIndex === -1) {
                errorList.push(el.id);
            }
            return getError(el.name || el.id, el.dataset.valRegex);
        } else if (el.dataset.valRequired && !el.value) {
            if (errIndex === -1) {
                errorList.push(el.id);
            }
            return getError(el.name || el.id, el.dataset.valRequired);
        } else {
            if (errIndex > -1) {
                if (!isForSubmition) {
                    errorList.splice(errIndex, 1);
                }
                if (el.tagName === "SELECT") {
                    var nextElem = el.nextSibling;
                    if (nextElem && nextElem.classList.contains("has-error")) {
                        $(nextElem).remove();
                        $(el).closest(".form-group").removeClass("has-error");
                    }
                }
            }
        }
        return null;
    };

    NonEloquaBase.prototype.submitObj = function submitObj(form) {
        return {
            url: form.attr("action"),
            type: form.data("ajax-method"),
            data: form.serialize()
        }
    };

    NonEloquaBase.prototype.submitFail = function submitFail(response) {
        var errors = {};
        if (response.status === 400) {
            var data = response.responseJSON;
            if (!data && response.responseText) {
                data = [{ Message: response.responseText, Name: "" }];
               }
            if (data) {
                for (var i = 0; i < data.length; i++) {
                    errors[data[i].Name] = data[i].Message;
                }
            }
        }
        if (response.status === 500) {
            var json = response.responseJSON;
            if (json) {
                console.log(json.Message);
                errorHandler.logError(json.Message);
            }
        }
        return errors;
    };

    NonEloquaBase.prototype.submitSuccess = function submitSuccess(response, form, result) {
        var responseResult = {
            resultTitle: null,
            resultText: null,
            sent: false
        }

        //LNRSSUP-549
        if (typeof _satellite !== 'undefined' && _satellite !== null && typeof _satellite.track === 'function') {
            console.log('contact form submits');
            _satellite.track('contact form submits');
        } else {
            console.log('Track function on _stellite object not available!');
        }

        if (response.status === 200) {
            form.find("input[type=text], textarea").val("");
            responseResult.resultTitle = response.title || null;
            responseResult.resultText = response.text || null;
            responseResult.sent = true;
            result.css("display", "");
            setTimeout(function () {
                result.addClass("in");
            }.bind(this), 100);
        }
        return responseResult;
    };

    NonEloquaBase.prototype.trackResponses = function trackResponses(formName, formValues) {
        eventManager.trigger(events.global.formSubmitted, formName, formValues);
    };    

    NonEloquaBase.prototype.trackErrors = function trackError(formName, formErrors) {
        eventManager.trigger(events.global.formErrors, formName, formErrors);
    };

    return new NonEloquaBase();
});
